<template>
  <div class="page-rnr-field-wrap">
    <slot />
    <div class="page-rnr-field-error">
      <div v-show="error" class="page-rnr-field-error-message">{{ errorMessage }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ErrorWrap',
  props: {
    // 是否需要展示错误
    error: {
      type: Boolean,
      default: false
    },
    // 错误展示值
    errorMessage: {
      type: String,
      default: '请输入内容'
    }
  }
}
</script>

<style lang="scss" scoped>
.page-rnr-field-wrap {
  .page-rnr-field-error {
    padding-bottom: 30px;
    padding-top: 12px;
    .page-rnr-field-error-message {
      color: #FF4C4F;
      font-size: 20px;
      font-weight: 400;
      height: 28px;
      padding-left: 75px;
      position: relative;
      font-weight: 400;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/login/components/ErrorWrap.vue